import useHttpMutation from 'data/firestore/useHttpMutation';

export default function useCreateCustomer() {
    return useHttpMutation({
        method: 'POST',
        pathname: '/customers',
    });
}
